function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40.5,
  cy: 40.5,
  r: 40.5,
  fill: "#003F4F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.6666 25.3333H25.3333C23.3166 25.3333 21.685 26.9833 21.685 28.9999L21.6666 50.9999C21.6666 53.0166 23.3166 54.6666 25.3333 54.6666H54.6666C56.6833 54.6666 58.3333 53.0166 58.3333 50.9999V28.9999C58.3333 26.9833 56.6833 25.3333 54.6666 25.3333ZM54.6666 32.6666L40 41.8333L25.3333 32.6666V28.9999L40 38.1666L54.6666 28.9999V32.6666Z",
  fill: "white"
});

function SvgMessagesa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesa);
export default __webpack_public_path__ + "static/media/messagesa.d4b677c0.svg";
export { ForwardRef as ReactComponent };